import React, { useState, useRef, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import googleBtn from "../images/googleBtn.png";
import Loading from "./Loading";
import CompanyJobsiteSelector from "./CompanyJobsiteSelector";
import ConsoleLogs from "./ConsoleLogs";
import Cookies from 'js-cookie';


const FileUploader = ({ onResponse, onCompanySelect, onJobsiteSelect }) => {
  const { accessToken, setAccessToken } = useAuth(); // Google Auth Context
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileUrl, setFileUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fileId, setFileId] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [tokenStatus, setTokenStatus] = useState(null);

  
  // Handle File Selection
  const handleFileSelect = (e) => {
    if (e.target.files?.length > 0) {
      const selectedFiles = Array.from(e.target.files);
      setFiles(selectedFiles);
      setFileUrl(URL.createObjectURL(selectedFiles[0]));
    }
  };

  // Drag and Drop Handlers
  const handleDragEnter = (e) => { e.preventDefault(); setIsDragging(true); };
  const handleDragLeave = (e) => { e.preventDefault(); setIsDragging(false); };
  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files?.length > 0) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      setFiles(droppedFiles);
      setFileUrl(URL.createObjectURL(droppedFiles[0]));
    }
  };

  const handleChooseFile = () => fileInputRef.current.click();

  // Upload File to Google Drive inside "AI-TakeOff" folder
  const uploadFileToDrive = async () => {
    if (!accessToken) {
      alert("❌ Please log in first!");
      return;
    }
    if (!files.length) {
      alert("❌ Please select a file first!");
      return;
    }
  
    setUploading(true);
    const file = files[0];
  
    try {
      // Step 1: Find or Create "AI-TakeOff" folder
      let folderId;
      const folderSearchResponse = await fetch(
        `https://www.googleapis.com/drive/v3/files?q=name='AI-TakeOff' and mimeType='application/vnd.google-apps.folder'&spaces=drive`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
  
      const folderSearchResult = await folderSearchResponse.json();
      if (folderSearchResult.files.length > 0) {
        folderId = folderSearchResult.files[0].id; // Folder exists, get ID
        console.log("📂 Found AI-TakeOff folder:", folderId);
      } else {
        // Folder doesn't exist, create it
        const folderCreateResponse = await fetch("https://www.googleapis.com/drive/v3/files", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: "AI-TakeOff",
            mimeType: "application/vnd.google-apps.folder",
          }),
        });
  
        const folderCreateResult = await folderCreateResponse.json();
        folderId = folderCreateResult.id;
        console.log("📂 Created AI-TakeOff folder:", folderId);
      }
  
      // Step 2: Upload file to the AI-TakeOff folder
      const metadata = { name: file.name, mimeType: file.type, parents: [folderId] };
      const form = new FormData();
      form.append("metadata", new Blob([JSON.stringify(metadata)], { type: "application/json" }));
      form.append("file", file);
  
      const uploadResponse = await fetch(
        "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart",
        {
          method: "POST",
          headers: { Authorization: `Bearer ${accessToken}` },
          body: form,
        }
      );
  
      const uploadResult = await uploadResponse.json();
      console.log("✅ File Uploaded:", uploadResult);
      setFileId(uploadResult.id);
  
      // Step 3: Make file public
      await fetch(`https://www.googleapis.com/drive/v3/files/${uploadResult.id}/permissions`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ role: "reader", type: "anyone" }),
      });
  
      console.log("✅ File uploaded successfully! Now calling the server...");
  
      // const serverResponse = await axios.get(
      //   `https://ai-takeoff-ttf-production.up.railway.app/AI-Takeoff/${uploadResult.id}`,
      //   { headers: { "Content-Type": "application/json" } }  // You might not need this header for GET requests
      // );

      const serverResponse = await axios.get(
        `http://127.0.0.1:5000/AI-Takeoff/${uploadResult.id}`,
        { headers: { "Content-Type": "application/json" } }  // You might not need this header for GET requests
      );

      if (serverResponse.data.file_name !== '') {
        onResponse(serverResponse.data);
        console.log('GOT SERVER RESPONSE');
        console.log(serverResponse.data);
        
      } else {
        alert(serverResponse.data.error);
      }
    } catch (error) {
      console.error("❌ Upload Error:", error);
    } finally {
      setUploading(false);
    }
  };

  const handleCompanySelect = (companyName) => {
    setSelectedCompany(companyName);
    onCompanySelect(companyName)
    console.log('Selected Company:', companyName);
  };

  const handleJobsiteSelect = (jobsite) => {
    setSelectedJobsite(jobsite);
    onJobsiteSelect(jobsite)
    console.log('Selected Jobsite:', jobsite);
  };



  return (
    <div className={`w-[80%] max-w-[970px] mx-auto mt-[50px] flex items-center justify-center rounded-xl p-8 text-center cursor-pointer border-gray-700 ${!accessToken ? '' : 'border'}`}
      onDragEnter={handleDragEnter} onDragLeave={handleDragLeave}
      onDragOver={handleDragOver} onDrop={handleDrop}
    >
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileSelect}
        accept="application/pdf"
      />

      {!accessToken ? (
        // <div className="w-[100%] h-[calc(100vh-90px)] flex items-center justify-center">
        //   <div className="border border-gray-600 px-[50px] py-[100px] rounded-lg flex items-center justify-center gap-[80px] -mt-[250px]">
        //     <p className="max-w-[400px] text-left">
        //       <b>🏗️ Welcome to TTF Scaffolding!</b> <br />
        //       AI-Takeoff is designed to optimize your workflow—sign in to leverage cutting-edge tools for accurate planning and faster execution.
        //     </p>
        //     <img src={googleBtn} className="w-[200px] cursor-pointer" onClick={login} />
        //   </div>
        // </div>
        <div>Token Expired</div>
      ) : (
        <div className="file-drop-content flex flex-col items-center gap-4">
          {files.length > 0 && (
          <>
            <div style={{ width: "800px", height: "500px", overflow: "auto", scrollbarWidth: "none"}}>
              <embed src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                type="application/pdf" style={{ width: "800px", height: "500px", border: "none" }} />
            </div>

            <CompanyJobsiteSelector  
              onCompanySelect={handleCompanySelect}
              onJobsiteSelect={handleJobsiteSelect}
            />

            <ConsoleLogs />

            <div className="w-[120%] -mb-[30px] mt-[50px] rounded-b-xl bg-darkGray py-[10px] px-[10px] flex flex-row justify-between items-center ">
            <ul className="text-gray-700">
              {files.map((file) => (
                <li key={file.name}>{file.name}</li>
              ))}
            </ul>
                      
            <button className="text-gray-600" onClick={uploadFileToDrive} disabled={uploading}>
              {uploading ? (
                <div className="flex items-center gap-[10px]">
                  <Loading /> Uploading ...
                </div>
              ) : (
                <div className="text-gray-600 hover:text-primary">
                  Upload & Process <i className="bi bi-arrow-right-circle ml-[10px]"></i>
                </div>
              )}
            </button>
            </div>
          </>
          )}

          {!files.length && (
            <div className="py-[100px] flex flex-col gap-[20px] px-[300px] rounded-lg">
              <i className="bi bi-folder-plus text-gray-400 text-[40px]"></i>
              <p className="text-gray-600">Drag and drop your file here</p>
              <p className="text-gray-600">or</p>
              <button className="text-primary" onClick={handleChooseFile}>Choose File</button>
            </div>
          )} 

        </div>
      )}
    </div>
  );
};

export default FileUploader;
